<div class="container-fluid cards-container">
    <chart-card
        id="continuityQualitySupplyMvIncidentChart"
        [title]="texts.mvIncident.title"
        [error]="mvIncidentChartError"
        [isLoading]="!mvIncidentChartDataSignal()[0].organizationId"
        [series]="mvIncidentChartSeries"
        [dataLabels]="mvIncidentChartDataLabels"
        [yaxis]="mvIncidentYaxis"
        [precision]="texts.mvIncident.precision"
        [grid]="mvIncidentChartGrid"
        [xaxisTitle]="texts.mvIncident.xaxisTitle"
        class="h-100">
    </chart-card>

    <chart-card
        id="continuityQualitySupplyLvIncidentChart"
        [title]="texts.lvIncident.title"
        [error]="lvIncidentChartError"
        [isLoading]="!lvIncidentChartDataSignal()[0].organizationId"
        [series]="lvIncidentChartSeries"
        [dataLabels]="lvIncidentChartDataLabels"
        [yaxis]="lvIncidentYaxis"
        [precision]="texts.lvIncident.precision"
        [grid]="lvIncidentChartGrid"
        [xaxisTitle]="texts.lvIncident.xaxisTitle"
        class="h-100">
    </chart-card>

    <chart-card
        id="continuityQualitySupplyIncidentComparisonChart"
        [title]="texts.incidentComparison.title"
        [descriptionTitle]="texts.incidentComparison.descriptionTitle"
        [descriptionContent]="texts.incidentComparison.descriptionContent"
        [error]="incidentComparisonChartError"
        [isLoading]="!incidentComparisonChartDataSignal()[0].organizationId"
        [type]="'rangeBar'"
        [dataLabels]="incidentComparisonDataLabels"
        [series]="incidentComparisonChartSeries"
        [plotOptions]="incidentComparisonPlotOptions"
        [customTooltip]="incidentComparisonCustomTooltip"
        [yaxis]="incidentComparisonYaxis"
        cardClass="h-100"></chart-card>
</div>
